import { Shield } from 'lucide-react';
import { IconSectionHeader } from '@/components/shared/IconSectionHeader';
import { PageDescription, PanelTitle } from '@reflex/ui/components/layout/Typography';
import type { PluginManifest } from '@/lib/plugin-registry';

export function PluginAuthSection({ plugin }: { plugin: PluginManifest }) {
  if (!plugin.server?.authProvider) return null;

  return (
    <section data-testid="plugin-detail-section-auth">
      <IconSectionHeader icon={Shield}>Auth Provider</IconSectionHeader>
      <div className="rounded-lg border p-3">
        <PanelTitle as="h3" size="sm">
          {plugin.server.authProvider.label}
        </PanelTitle>
        <PageDescription className="mt-0.5 font-mono text-xs">
          {plugin.server.authProvider.name}
        </PageDescription>
      </div>
    </section>
  );
}
